var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 37 37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        clip-path: url(#clippath-2);\n      }\n\n      .cls-2, .cls-3 {\n        stroke-width: 0px;\n      }\n\n      .cls-3 {\n        fill: none;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 68,
    y: -203,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    width: 37,
    height: 37
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3.63,32.75c0-8.88,0-17.77,0-26.65.24.16.49.3.72.47,6.49,4.55,12.97,9.11,19.46,13.66,1.49,1.05,2.21,1.05,3.69.03,6.53-4.54,13.06-9.08,19.6-13.62.24-.17.5-.33.84-.55v7.76c0,5.94,0,11.88-.01,17.82,0,.5-.09,1.05-.31,1.48-.52,1.01-1.45,1.28-2.54,1.27-12.86-.01-25.72,0-38.58,0-.23,0-.46,0-.69-.02-.7-.07-1.25-.41-1.67-.96-.17-.23-.33-.46-.49-.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M7.52,3.44h36.47c-.27.23-.42.39-.59.51-5.66,3.96-11.33,7.91-16.99,11.88-.43.3-.73.37-1.21.04-5.68-3.99-11.37-7.96-17.06-11.93-.16-.11-.31-.24-.63-.49Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.eef8fba276f43812ec990908ac3604bc.svg";
export { ForwardRef as ReactComponent };